import type { ReactElement } from 'react';
import { skeletonLine } from '@/components/ui/skeleton';

const ROWS = 5;

/** Skeleton con la forma del directorio (UX-LOAD-01): una línea por usuario con su
 *  nombre/correo, empresa, estado y roles. Nunca un spinner genérico. */
export function UsersSkeleton(): ReactElement {
  return (
    <div
      className="card rise"
      data-testid="users-skeleton"
      aria-busy="true"
      aria-label="Cargando usuarios"
    >
      <div className="cb">
        {Array.from({ length: ROWS }, (_, i) => (
          <div key={i} style={{ display: 'grid', gap: 6, padding: '10px 0' }}>
            <div className={skeletonLine({ width: 40 })} />
            <div className={skeletonLine({ width: 25 })} />
            <div className={skeletonLine({ width: 60 })} />
          </div>
        ))}
      </div>
    </div>
  );
}
